export default __webpack_public_path__ + "static/media/superpunch.b2d00a99.png";